import styled from 'styled-components'
import { CompanyName } from '../CompanyHeader/HeaderBasicInformation.styles'

export const InvestorGroupName = styled(CompanyName)`
  font-size: 1.4rem;
  cursor: pointer;
`
